import LocalizedStrings, { LocalizedStringsMethods } from "react-localization"

export interface ILabels extends LocalizedStringsMethods {
  Welcome: string
  WelcomeListOne: string
  WelcomeListTwo: string
  WelcomeListThree: string
  WelcomeListFour: string
  WelcomeListFive: string
  NotLiveNotice: string

  ShipmentType: string
  ShipmentTypePickup: string
  ShipmentTypeDelivery: string

  ShipWithinCanadaNotice: string

  KitType: string

  HowManyKits: string
  HowManyKitsV3: string
  HowManyKitsValidation: string
  UserID: string
  CovidKit: string
  CovidKitOrdered: string
  PickupInventoryWarning: string

  Location: string
  PickupLocation: string
  LocationValidation: string
  SearchLocation: string
  ProvinceFilterHelp: string
  LocationSearchHelp: string
  LocationListInstructions: string
  LocationsShown: string
  ViewMap: string
  NoLocations: string

  NameTitle: string
  FirstName: string
  FirstNameValidation: string
  LastName: string
  LastNameValidation: string

  DoubleCheckWarningSubmit: string
  DoubleCheckWarningConfirm: string
  AddressTitle: string
  AddressSubtitle: string
  StreetName: string
  StreetNamePlaceholder: string
  StreetNameValidation: string
  BuildingNumber: string
  BuildingNumberValidation: string
  Unit: string
  City: string
  CityPlaceholder: string
  CityValidation: string
  PostalCode: string
  PostalCodeValidation: string
  Province: string
  ProvinceValidation: string

  Confirm: string
  Submit: string
  Saving: string
  Select: string

  FormSubmitted: string
  FormV2Submitted: string
  FormV3Submitted: string
  CantSubmitErrorInternal: string
  CantSubmitErrorReceivedAll: string
  CantSubmitErrorReceivedSome: string

  Alberta: string
  BritishColumbia: string
  Manitoba: string
  NewBrunswick: string
  NewfoundlandAndLabrador: string
  NovaScotia: string
  Ontario: string
  PrinceEdwardIsland: string
  Quebec: string
  Saskatchewan: string
  NorthwestTerritories: string
  Nunavut: string
  Yukon: string

  Yes: string
  No: string

  UserNotValid: string

  IAMHowManyKits: string
  IAMHowManyKitsValidation: string
  IAMFormSubmittedOrderSubmitted: string
  IAMFormSubmittedThankYou: string
  IAMFormSubmittedReturn: string

  FormInvalid: string
}

export const AppLabels: ILabels = new LocalizedStrings({
  en: {
    Welcome: "Welcome to the HIV self-test order form.",
    WelcomeListOne:"You can order a total of 2 free HIV kits",
    WelcomeListTwo:"You don’t have to order them all at once",
    WelcomeListThree:"You can order your kits for delivery to your address or another address",
    WelcomeListFour:"You can pick them up at one of our locations across Canada",
    WelcomeListFive:"Please note that you can’t pick up kits at a location without ordering them through the form first.",
    NotLiveNotice: "<strong>NOTICE:</strong> We're getting ready to launch the I'm Ready research program but we’re not live yet and neither is this order form. Follow us on Twitter, Facebook and Instagram at @ImReadyJagis for updates.",

    ShipmentType: "Do you want to order your kit(s) for pick up or for delivery?",
    ShipmentTypePickup: "Pick up my kit(s)",
    ShipmentTypeDelivery: "Have my kit(s) delivered to my home or another address",

    ShipWithinCanadaNotice: "I AM is able to ship HIV self-test kits to addresses located in Canada ONLY",

    KitType: "Which HIV self-test would you like to order",

    HowManyKits: "How many HIV self-test kits do you want? You can order a total of {1} free kits. You don't have to order them all now.",
    HowManyKitsV3: "How many HIV self-test kits do you want? You can order a total of 5 free kits from this research program",
    HowManyKitsValidation: "The number of self-test kits must be between 1 and {1}.",
    UserID: "Unique user ID (from App):",
    CovidKit: "Would you like one package of COVID antigen test kits?",
    CovidKitOrdered: "You have already ordered the one COVID antigen test avaliable to you.",
    PickupInventoryWarning: "Due to changes in inventory, please contact the pickup site for test availability prior to coming to the site. For contact information please see: <a target='_blank' href='https://www.readytoknow.ca/supporting-resources/'>https://www.readytoknow.ca/supporting-resources/ {1}</a>",

    Location: "Which of the I'm Ready pickup locations do you intend to pickup your test kits from:",
    PickupLocation: "Pickup Location",
    LocationValidation: "Location is required.",
    SearchLocation: "Search by street city, or postal code...",
    ProvinceFilterHelp: "Filters the list of pickup locations below to the selected province. This filter is disabled while a pickup location is selected.",
    LocationSearchHelp: "Type to filter the list of pickup locations below by name or address. This search is disabled while a pickup location is selected.",
    LocationListInstructions: "List of pickup locations. Use Tab to move between locations, and press Enter or Space to select one. Selecting a location again clears your choice and re-enables the filters.",
    LocationsShown: "{1} pickup locations shown",
    ViewMap: "View Map",
    NoLocations: "There are no pick-up locations here, please try another or choose the delivery option to get the self-tests delivered",

    NameTitle: "Please enter a first and last name. <strong>These can be your legal names or you can make them up.</strong>",
    FirstName: "First name",
    FirstNameValidation: "First name is required. This can be your legal name or you can make one up.",
    LastName: "Last name",
    LastNameValidation: "Last name is required. This can be your legal name or you can make one up.",

    DoubleCheckWarningSubmit: "<strong>Please double check that you have entered your correct mailing address before pressing \"submit\" on this form.</strong> We ship with Canada Post and want to make sure the tests get to you. Please be aware that we cannot make changes to your mailing address once your order has been submitted, and can't do anything about missing or misdirected packages.",
    DoubleCheckWarningConfirm: "<strong>Please double check that you have entered your correct mailing address before pressing \"confirm\" on this form.</strong> We ship with Canada Post and want to make sure the tests get to you. Please be aware that we cannot make changes to your mailing address once your order has been submitted, and can't do anything about missing or misdirected packages.",
    AddressTitle: "Please enter the address that you want your kit(s) delivered to. This can be your home or another address.",
    AddressSubtitle: "Note: We use your address information only to send you a kit. It's not stored on this app",
    BuildingNumber: "Building number (or PO box address) ",
    BuildingNumberValidation: "Building number or PO box address is required.",
    StreetName: "Street name (or station code, if using a PO box) ",
    StreetNamePlaceholder: "Street",
    StreetNameValidation: "Street name, or station number if you're using a PO box, is required.",
    Unit: "Unit",
    City: "City",
    CityPlaceholder: "City",
    CityValidation: "City is required.",
    PostalCode: "Postal code",
    PostalCodeValidation: "Postal code is required.",
    Province: "Province",
    ProvinceValidation: "Province is required.",

    Confirm: "Confirm",
    Submit: "Submit",
    Saving: "Saving",
    Select: "Select...",

    FormSubmitted: "<p>Thank you! You will receive your kit(s) within two weeks if you ordered them for delivery. If you chose to pick up your kit(s), visit any of our <a href='https://www.readytoknow.ca/supporting-resources/'>pickup locations</a> to claim your kits using the self-test kit pickup codes you can find in the menu screen of the I'm Ready, Test app. This is at the bottom-right of your screen when you have the app open.</p><p>PrEP—short for pre-exposure prophylaxis—is a medication taken by people who are HIV-negative to prevent HIV infection. When taken as prescribed, PrEP is highly effective and can reduce the risk of getting HIV by more than 99%. Even if you test negative for HIV, learn more on how to access PrEP below.</p><p><a class='btn btn-secondary w-100' href='{goFreddyUrl}'>Get PrEP</a></p>",
    FormV2Submitted: `<div class='success-v2'>
        <div class='headline'>Thank you</div>
        <p>You will receive your kit(s) within two weeks if you ordered them for delivery. If you chose to pick up your kit(s), visit any of our <a href='https://www.readytoknow.ca/supporting-resources/'>pickup locations</a> to get your kits.</p>
        <p><strong>We want you to know that no matter what your result is, you have options and support available. You’re not alone.</strong></p>
        <p>I’m Ready was designed to provide you with everything needed for testing and what happens after you test.</p>
        <p>While you’re waiting for your test to arrive, click below to learn more about prevention and treatment options that can work for you.</p>
        <div class='row'>
          <div class='col-md-6 col-12 mb-3'><button type='button' id='get-prep' class='btn btn-outline-secondary w-100'>More Information on PrEP</button></div>
          <div class='col-md-6 col-12 mb-3'><button type='button' id='get-treatment' class='btn btn-outline-secondary w-100'>More Information on HIV Treatment</button></div>
        </div>
      </div>
    `,
    FormV3Submitted: "Thank you! Your kits are on the way!",
    CantSubmitErrorInternal: "Error submitting form, internal server error",
    CantSubmitErrorReceivedAll: "Unfortunately, we have a limited number of free HIV self-testing kits and you have already ordered your maximum of {1}. Is there anything we can do to support you or connect you to other resources for testing, care and prevention? We suggest booking an appointment with one of our peer navigators through our <a href='https://connect.im-ready.ca/booking/steps/matching'>I'm Ready, Talk secure telehealth service.</a>",
    CantSubmitErrorReceivedSome: "You can order a total of {3} kits. You have already ordered {1}, so you can order {2} more.",

    Alberta: "Alberta",
    BritishColumbia: "British Columbia",
    Manitoba: "Manitoba",
    NewBrunswick: "New Brunswick",
    NewfoundlandAndLabrador: "Newfoundland and Labrador",
    NovaScotia: "Nova Scotia",
    Ontario: "Ontario",
    PrinceEdwardIsland: "Prince Edward Island",
    Quebec: "Quebec",
    Saskatchewan: "Saskatchewan",
    NorthwestTerritories: "Northwest Territories",
    Nunavut: "Nunavut",
    Yukon: "Yukon",

    Yes: "Yes",
    No: "No",
    UserNotValid: "<strong>Attention! We have important updates for you</strong>. To ensure the best experience with our app, please <strong>update to the latest version</strong>. Once you've updated, you'll be prompted to switch to our new program for even more opportunities to get resources, free HIV self-test kits and linkage to care information. Please note that this will require an additional update. If you choose to switch to the new program, your data stored on the app will be deleted. To get started, simply click on the link for <a href='https://apps.apple.com/us/app/im-ready-test/id1547497367/'>iOS</a> or <a href='https://play.google.com/store/apps/details?id=com.unityhealthtoronto.imreadytest&hl=en&gl=US&pli=1/'>Android<a/> and follow the instructions.",

    IAMHowManyKits: "How many HIV self-test kits do you want? You can order up to 5 free kits.",
    IAMHowManyKitsValidation: "The number of self-test kits must be between 1 and 5.",
    IAMFormSubmittedOrderSubmitted: "Your order form has been submitted successfully",
    IAMFormSubmittedThankYou: "THANK YOU!",
    IAMFormSubmittedReturn: "Please use the main navigation to continue exploring the I AM website",

    FormInvalid: "Some fields are missing or contain invalid values. Please review the form and make any necessary corrections."
  },
  fr: {
    Welcome: "Bienvenue sur le formulaire de commande de trousses d’autodépistage du VIH.",
    WelcomeListOne:"Vous pouvez commander jusqu’à 2 trousses de test VIH gratuitement",
    WelcomeListTwo:"Vous n’avez pas à les commander en une seule fois",
    WelcomeListThree:"Vous pouvez effectuer une commande pour livraison à votre adresse ou à une autre adresse",
    WelcomeListFour:"Vous pouvez ramasser vos trousses à un de nos points de collecte partout au Canada",
    WelcomeListFive:"Veuillez noter que vous ne pouvez pas obtenir de trousses à un point de collecte sans les avoir commandées auparavant via le formulaire.",
    NotLiveNotice: "<strong>AVIS :</strong> Nous sommes prêts à lancer le programme de recherche J’agis, mais le site Web et ce formulaire de commande n’ont pas encore été mis en ligne. Suivez-nous sur Twitter, Facebook et Instagram à @ImReadyJagis pour obtenir des mises à jour.",

    ShipmentType: "Voulez-vous que votre commande de trousse(s) soit livrée ou préparée pour ramassage?",
    ShipmentTypePickup: "Ramassage",
    ShipmentTypeDelivery: "Livraison",

    ShipWithinCanadaNotice: "JE SUIS/I AM peut envoyer des trousses d'autodépistage du VIH UNIQUEMENT à des adresses situées au Canada",

    KitType: "Quelle trousse d'autodépistage du VIH souhaitez-vous commander ?",

    HowManyKits: "Combien de trousses d’autodépistage du VIH désirez-vous? Vous pouvez commander jusqu’à {1} trousses de test VIH gratuitement. Vous n’avez pas à les commander en une seule fois.",
    HowManyKitsV3: "Combien voulez-vous de trousses d’autodépistage du VIH? Vous pouvez commander un total de cinq gratuites auprès de ce programme de recherche",
    HowManyKitsValidation: "Le nombre de trousses doit être compris entre 1 et {1}.",
    UserID: "Identifiant unique d’utilisateur (par l’application): ",
    CovidKit: "Voulez-vous une trousse de tests antigéniques de dépistage de la COVID-19?",
    CovidKitOrdered: "Vous avez déjà commandé le test antigénique de dépistage de la COVID-19 qui était prévu pour vous.",
    PickupInventoryWarning: "En raison de constantes variations d’inventaires, merci de contacter le site de ramassage pour vérifier la disponibilité de votre commande avant de vous déplacer. Pour les coordonnées des sites, veuillez visiter : <a target='_blank' href='https://www.readytoknow.ca/fr/supporting-resources/'>https://www.readytoknow.ca/fr/supporting-resources/ {1}</a>",

    Location: "Dans quel point de collecte I’m Ready/J’agis souhaitez-vous ramasser vos trousses?",
    PickupLocation: "Lieu de collecte",
    LocationValidation: "Lieu requis.",
    SearchLocation: "Rechercher par rue, ville ou code postal...",
    ProvinceFilterHelp: "Filtre la liste des points de collecte ci-dessous selon la province choisie. Ce filtre est désactivé lorsqu’un point de collecte est sélectionné.",
    LocationSearchHelp: "Tapez pour filtrer la liste des points de collecte ci-dessous par nom ou adresse. Cette recherche est désactivée lorsqu’un point de collecte est sélectionné.",
    LocationListInstructions: "Liste des points de collecte. Utilisez la touche Tab pour passer d’un lieu à l’autre et appuyez sur Entrée ou sur la barre d’espacement pour en sélectionner un. Sélectionnez de nouveau le même lieu pour annuler votre choix et réactiver les filtres.",
    LocationsShown: "{1} points de collecte affichés",
    ViewMap: "Voir la carte",
    NoLocations: "Aucun point de ramassage n'est disponible à proximité. Merci de rechercher pour un autre emplacement ou de choisir la livraison pour obtenir vos trousses d'autodépistage.",

    NameTitle: "Veuillez saisir un prénom et un nom de famille. <strong>Vous pouvez utiliser vos véritables nom et prénom ou vous pouvez en inventer.</strong>",
    FirstName: "Prénom",
    FirstNameValidation: "Le prénom est requis. Il peut s’agir de votre prénom légal ou vous pouvez en inventer un.",
    LastName: "Nom de famille",
    LastNameValidation: "Le nom de famille est requis. Il peut s’agir de votre prénom légal ou vous pouvez en inventer un.",

    DoubleCheckWarningSubmit: "<strong>Veuillez vérifier de nouveau que vous avez entré correctement l’adresse postale de destination avant de cliquer sur le bouton « Commander » de ce formulaire. </strong>Nos colis sont expédiés par Postes Canada et nous voulons nous assurer que les tests vous parviennent. Veuillez noter que nous ne pouvons pas apporter de modifications à votre adresse postale une fois que votre commande a été soumise et que nous ne pourrons être tenus responsables des colis non ou mal acheminés.",
    DoubleCheckWarningConfirm: "<strong>Veuillez vérifier de nouveau que vous avez entré l’adresse postale correcte avant d’appuyer sur Confirmer sur ce formulaire.</strong> Nos colis sont expédiés par Postes Canada et nous voulons nous assurer que les tests d’audodépistage vous parviennent. Veuillez noter que nous ne pouvons pas apporter de modifications à votre adresse postale une fois que votre commande a été soumise et que nous ne pourrons être tenus responsables des colis manquants ou mal acheminés.",
    AddressTitle: "Veuillez entrer l’adresse à laquelle vous voulez que votre/vos trousse(s) soient livrées. Il peut s’agir de votre domicile ou d’une autre adresse.",
    AddressSubtitle: "Remarque : Nous utilisons vos coordonnées uniquement pour vous envoyer une trousse. Elles ne sont pas archivées sur cette application.",
    StreetName: "Nom de rue (ou code de la succursale, si vous utilisez une boîte postale)",
    StreetNamePlaceholder: "Nom de rue",
    StreetNameValidation: "Le nom de rue, ou le numéro de la succursale si vous utilisez une boîte postale, est requis.",
    BuildingNumber: "Numéro d’immeuble (ou adresse de la boîte postale)",
    BuildingNumberValidation: "Le numéro d’immeuble ou l’adresse de la boîte postale est requis.",
    Unit: "Unité",
    City: "Ville",
    CityPlaceholder: "Ville",
    CityValidation: "La ville est requise.",
    PostalCode: "Code postal",
    PostalCodeValidation: "Le code postal est requis.",
    Province: "Province",
    ProvinceValidation: "La province est requis.",

    Confirm: "Confirmer",
    Submit: "Commander",
    Saving: "Soumettre",
    Select: "Choisir...",

    FormSubmitted: "<p>Merci ! Si vous avez demandé une livraison, vous recevrez votre commande sous 2 semaines. Pour un ramassage, merci de vous rendre dans n’importe lequel de nos <a href='https://www.readytoknow.ca/fr/supporting-resources/'>points de collecte</a>. Vous aurez besoin du code de ramassage disponible dans le menu de l’application I’m Ready-Test / J’agis-Je me dépiste. Ce code est situé en bas à droite de l’écran de menu de l’application.</p><p>La PreP/PPrE (Prophylaxie pré-exposition) est un traitement de prévention du VIH destiné aux personnes séronégatives. Prise suivant les indications, la PrEP/PPrE est très efficace et peut réduire le risque de transmission du VIH par plus de 99%. Même si votre dépistage du VIH est négatif, apprenez-en plus sur la PrEP/PPre ici.</p><p><a class='btn btn-secondary w-100' href='{goFreddyUrl}'>Accéder à la PreP</a></p>",
    FormV2Submitted: `<div class='success-v2'>
        <div class='headline'>Merci</div>
        <p>Si vous avez choisi de commander avec livraison, vous recevrez votre trousse (vos trousses) sous deux semaines. Si vous avez chois le ramassage, merci de vous rendre dans n’importe lequel de nos points de collecte. <a href='https://www.readytoknow.ca/fr/supporting-resources/'>Points de collecte</a> pour ramasser votre trousse (vos trousses).</p>
        <p><strong>Nous tenons à vous faire savoir que quels que soient vos résultats de test, nous avons des options de service et de soutien à votre disposition. Vous n’êtes pas seul·e !</strong></p>
        <p>Le programme I’m Ready/J’agis a été conçu pour vous procurer tout ce dont vous avez besoin pour vous tester ET pour gérer les étapes qui suivent un test.</p>
        <p>Pendant que vous attendez pour recevoir votre trousse, nous vous invitons à cliquer sur les liens ci-dessous pour en apprendre plus sur les options de prévention et de traitements qui pourraient être adaptées à vos besoins.</p>
        <div class='row'>
          <div class='col-md-6 col-12 mb-3'><button type='button' id='get-prep' class='btn btn-outline-secondary w-100'>Plus d’infos sur la PreP/PPrE</button></div>
          <div class='col-md-6 col-12 mb-3'><button type='button' id='get-treatment' class='btn btn-outline-secondary w-100'>Plus d’infos sur les traitements HIV</button></div>
        </div>
      </div>
    `,
    FormV3Submitted: "Merci! Vos kits sont en route!",
    CantSubmitErrorInternal: "Erreur de serveur interne",
    CantSubmitErrorReceivedAll: "Malheureusement, nous disposons d’un nombre limité de trousses d’autodépistage du VIH gratuites et vous avez déjà commandé le maximum de trois trousses. Pouvons-nous faire quelque chose pour vous soutenir ou vous mettre en contact avec d’autres ressources liées au dépistage, aux soins et à la prévention? Nous suggérons de prendre rendez-vous avec l’un de nos pairs navigateurs par l’intermédiaire de notre service de télésanté sécurisé <a href='https://connect.im-ready.ca/booking/steps/matching'>J’agis - J’échange</a>.",
    CantSubmitErrorReceivedSome: "Vous pouvez commander un total de {3} trousses. Vous en avez déjà commandé {1}; vous pouvez donc en commander {2} de plus.",

    Alberta: "Alberta",
    BritishColumbia: "Colombie-Britannique",
    Manitoba: "Manitoba",
    NewBrunswick: "Nouveau-Brunswick",
    NewfoundlandAndLabrador: "Terre-Neuve-et-Labrador",
    NovaScotia: "Nouvelle-Écosse",
    Ontario: "Ontario",
    PrinceEdwardIsland: "île du Prince-Édouard",
    Quebec: "Québec",
    Saskatchewan: "Saskatchewan",
    NorthwestTerritories: "les Territoires du Nord-Ouest",
    Nunavut: "Nunavut",
    Yukon: "Yukon",

    Yes: "Oui",
    No: "Non",

    UserNotValid: "<strong>Attention ! Nous avons des nouvelles importantes à partager avec vous</strong>. Afin de profiter d’une expérience optimale avec notre application, <strong>merci de faire une mise à jour vers la dernière version</strong>. Une fois celle-ci effectuée, vous serez invité.e à embarquer sur notre nouveau programme pour avoir accès à encore plus d'opportunités d'obtenir du soutien, des trousses gratuites d'autodépistage du VIH et des informations sur l’arrimage aux soins. Veuillez prendre note que cela nécessitera une mise à jour supplémentaire. Si vous décidez de passer à notre nouveau programme, vos données stockées dans l'application seront supprimées. Pour commencer, il suffit de cliquer sur le lien pour <a href='https://apps.apple.com/us/app/im-ready-test/id1547497367/'>iOS</a> ou celui pour <a href='https://play.google.com/store/apps/details?id=com.unityhealthtoronto.imreadytest&hl=en&gl=US&pli=1/'>Android<a/> et de suivre les instructions.",

    IAMHowManyKits: "Combien voulez-vous de trousses d’autotest du VIH? Vous pouvez commander jusqu'à cinq trousses gratuites.",
    IAMHowManyKitsValidation: "Le nombre de trousses doit être compris entre 1 et 5.",
    IAMFormSubmittedOrderSubmitted: "Votre formulaire de commande a bien été pris en compte",
    IAMFormSubmittedThankYou: "MERCI!",
    IAMFormSubmittedReturn: "Merci d'utiliser le menu principal pour poursuivre la visite du site web JE SUIS/I AM",

    FormInvalid: "Certains champs sont manquants ou contiennent des valeurs non valides. Veuillez vérifier le formulaire et apporter les corrections nécessaires."
  }
});